const NS = 'SectionsPlan';

// requiring html templates so that hot reloading works
const template = require('./sectionsPlan.html');

export default function SectionsPlan() { // as sectionsPlan
  "ngInject";

  return {
    restrict: 'E',
    replace: true,
    template,
    scope: {
      config: '=',
      ready: '=',
      accessor: '=',
      onCancel: '=',
      onSave: '='
    },
    controller,
    controllerAs: 'vm',
    bindToController: true
  };

  function controller(
    SnapService, Plan, Structure, PlanConst, Command, $element, $timeout, $scope, $rootScope, unregister
  ) {
    "ngInject";

    const vm = this;

    //functions
    vm.save = save;
    vm.cancel = cancel;
    vm.showEditor = showEditor;
    vm.hideEditor = hideEditor;
    vm.stackStructure = stackStructure;
    vm.removeStructure = removeStructure;
    vm.refreshStructure = refreshStructure;

    //model
    vm.structureEditor = {
      item: null,
      form: null
    };

    vm.canUndo = false;
    vm.canRedo = false;

    var defaults = {
      onSelectedElement: _.bind(function (element) {
        showEditor(element);
      }, this),
      onDeselectedElement: _.bind(function () {
        hideEditor();
      }, this),
    };

    var options = _.extend({}, defaults, vm.config);
    vm.plan = new Plan(PlanConst.Mode.Restaurant, options);

    var listeners = [];
    //Listen for memento change, refresh undo/redo buttons status
    listeners.push($rootScope.$on('memento-changed', function (evt, info) {
      vm.mementoStatus = info;
      $scope.$evalAsync();
    }));
    listeners.push($scope.$on('$destroy', () => unregister(listeners)));

    $timeout(function () {
      vm.plan.render(Snap($element.find('svg')[0])); //jshint ignore:line
      vm.dom = vm.plan.dom;
      if (vm.accessor) {
        vm.accessor.enablePlan = enablePlan;
        vm.accessor.setSectionsLayouts = setSectionsLayouts;
        vm.accessor.setStructures = setStructures;
        vm.accessor.selectLayer = selectLayer;
        vm.accessor.saveState = saveState;
      }
      vm.ready = true;
    }, 100);

    function enablePlan(enabled) {
      vm.plan.enable(enabled);
      $scope.$evalAsync();
    }

    function setSectionsLayouts(layouts) {
      return vm.plan.setSectionsLayouts(layouts);
    }

    function setStructures(structures) {
      vm.plan.setRestaurantStructures(structures);
    }

    function selectLayer(layer) {
      vm.plan.selectLayer(layer);
    }

    function saveState(command) {
      command = command || Command.createUserSave();
      vm.plan.saveState(command);
    }

    //Show element corresponding editor, plan guarantee that no editor is actually open
    function showEditor(element) {
      switch (element.model.type) {
        case 'structure':
          vm.structureEditor.hasLabel = Structure.hasLabel(element.model.subType);
          vm.structureEditor.hasFillTheme = Structure.hasFillTheme(element.model.subType);
          vm.structureEditor.structureName = Structure.getTypeName(element.model.subType);
          vm.structureEditor.form.displayErrors = false;
          vm.structureEditor.form.$setPristine();
          vm.structureEditor.item = element;
          vm.structureEditor.edit = true;
          $scope.$evalAsync();
          break;
      }
    }

    function hideEditor() {
      if (vm.structureEditor.item) {
        vm.structureEditor.item = null;
        $scope.$evalAsync();
      }
    }

    function stackStructure(direction) {
      if (vm.structureEditor.item) {
        vm.plan.stackStructure(vm.structureEditor.item, direction);
      }
    }

    function removeStructure() {
      if (vm.structureEditor.item) {
        vm.plan.removeStructure(vm.structureEditor.item, vm.structureEditor.item.mode);
      }
    }

    function refreshStructure() {
      if (vm.structureEditor.item) {
        vm.plan.refreshStructure(vm.structureEditor.item);
      }
    }

    function save() {
      if (typeof vm.onSave === 'function') {
        vm.onSave(vm.plan.getData());
      }
    }

    function cancel() {
      if (typeof vm.onCancel === 'function') {
        vm.onCancel();
      }
    }
  }
}
